
const apiConfig = {
    // LOcal
    // apiUrl: 'https://localhost:7011/api/',
    // Live
    apiUrl: 'https://r-api.off-ease.com/api/',
    // Test
    //apiUrl: 'https://demo-api.solegaze.com/api/',
    apiKey: 'Lieda1002',
};

export default apiConfig;
